
import '.././node_modules/bootstrap/dist/css/bootstrap.min.css';
import React, {  } from 'react';
import {Button,Modal,Accordion,Card,Table ,Badge,Image,Row,Col,Container} from 'react-bootstrap'; 

import './Code.css'

import watchos from './img/gold.jpg';
import { useState } from 'react';
import {Helmet} from 'react-helmet'

import Snowfall from 'react-snowfall'

function MainPage(){

return(
    <>

    <h2>Gold Package </h2>
    <Snowfall  
   />
   <div>
   <Image src={ watchos} width={300} height={300} />
   <div >
      <Table striped bordered hover>
      <thead>
        <tr>
          <th>#</th>
          <th>Gold</th>
          <th>Min</th>
          <th>Max</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Half Body</td>
          <td>$652</td>
          <td>$950</td>
        </tr>
        <tr>
          <td>2</td>
          <td>Half Body with Rigging</td>
          <td>$750</td>
          <td>$1050</td>
        </tr>
        <tr>
        <td>3</td>
          <td>Full Body</td>
          <td>$700</td>
          <td>$1100</td>
        </tr>
        <tr>
        <td>4</td>
        <td>Full Body With Rigging</td>
          <td>$900</td>
          <td>$1300</td>
        </tr>
      </tbody>
    </Table>
</div>

   </div>
   
   
    <div style={{color:'blue'}}>



</div>
</>


)

}
export default MainPage;